module.exports = __webpack_public_path__ + "img/stock5.84b3b7bb.png";